export const ROUTER_PARAM_PACKAGE_GROUP = "packageGroup";
export const ROUTER_PARAM_LANGUAGE = "languageGroup";
